/* eslint new-cap: "off", no-param-reassign: "off" */

'use strict';

const geScriptLoaderScript = require('./../../../../../../../dependencies/global-e/cartridges/int_globale_sfra/cartridge/client/default/js/geScriptLoader');
const GeScriptLoader = geScriptLoaderScript.GeScriptLoader;
const Helpers = geScriptLoaderScript.Helpers;

/**
 * Init events
 */
GeScriptLoader.prototype.initPayByLinkEvent = function () {
    // 'Pay By Link' feature
    if (document.querySelector('.pay-by-link-button-wrapper')) {
        document.querySelector('.pay-by-link-button-wrapper').addEventListener('click', this.onPayByLinkHandler, false);
    }
};

/**
 * Pay By Link Handler
 * @param {Object} data - Event data
 */
GeScriptLoader.prototype.onPayByLinkHandler = function (data) {
    let PayByLinkMessage = document.querySelector('.pay-by-link-message');
    try {
        let payByLink = document.querySelector('.pay-by-link-button-wrapper');
        let geIframe = document.querySelector('#gle_iframe');
        Helpers.makeJsonAjaxCall(payByLink.dataset.createOrderUrl + '?cartToken=' + geIframe.dataset.cartToken, 'POST', JSON.stringify(data))
            .then(function (response) {
                // eslint-disable-line no-unused-vars
                response = JSON.parse(response);
                if (response.success && response.orderCreateResult && response.orderCreateResult.gePayByLinkUrl) {
                    PayByLinkMessage.hidden = false;
                    PayByLinkMessage.innerHTML = response.orderCreateResult.message;
                    PayByLinkMessage.classList.add('alert-success');
                    payByLink.hidden = true;
                } else {
                    PayByLinkMessage.hidden = false;
                    PayByLinkMessage.innerHTML = response.errorMessage || response.orderCreateResult.errorMessage;
                    PayByLinkMessage.classList.add('alert-danger');
                }
            })
            .catch(function (e) {
                PayByLinkMessage.innerHTML = e;
            });
    } catch (e) {
        PayByLinkMessage.innerHTML = e;
    }
};

//--------------------------------------------------
// Initialisation
//--------------------------------------------------

/**
 * General init function
 */
function init() {
    var geScriptLoader = new GeScriptLoader();
    geScriptLoader.init();
    geScriptLoader.initPayByLinkEvent();
}

/**
 * Run initialisation once document is loaded
 */
if (/complete|interactive|loaded/.test(document.readyState)) {
    init();
} else {
    document.addEventListener('DOMContentLoaded', init);
}

module.exports = {
    Helpers: Helpers,
    GeScriptLoader: GeScriptLoader,
};
